module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bfsp-box"
  }, [_c('div', {
    staticClass: "bfsp-close",
    on: {
      "click": _vm.handleBack
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "22",
      "height": "22"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 6l12 12M18 6L6 18",
      "stroke": "#FFFFFF",
      "stroke-width": "2.4",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('duanshippin', {
    attrs: {
      "userId": _vm.userId,
      "videoId": _vm.videoId,
      "isHost": _vm.isHost
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95adaa70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/bofangshipin/bofangshipin.vue
// module id = 1042
// module chunks = 1